import {
  getAllModulesInitActions,
  getSectionLayoutInitAction,
  getPageInfoInitActions,
} from './common';

import { setSelectedFolder } from '../../actions/backroomSection';

export function getBackroomSectionInitActions(responseData, requestParams) {
  return [
    getSectionLayoutInitAction(responseData, 'backroom'),
    ...getPageInfoInitActions(responseData, requestParams),
    ...getAllModulesInitActions(responseData, requestParams),
    setSelectedFolder(requestParams.folder),
  ].filter(action => action);
}
